// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AccountSettingsController from "./account_settings_controller"
application.register("account-settings", AccountSettingsController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import DarkModeTogglerController from "./dark_mode_toggler_controller"
application.register("dark-mode-toggler", DarkModeTogglerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicNestedFormController from "./dynamic_nested_form_controller"
application.register("dynamic-nested-form", DynamicNestedFormController)

import EquivalenciesController from "./equivalencies_controller"
application.register("equivalencies", EquivalenciesController)

import Filters__DateRangeController from "./filters/date_range_controller"
application.register("filters--date-range", Filters__DateRangeController)

import Filters__FilterController from "./filters/filter_controller"
application.register("filters--filter", Filters__FilterController)

import FocusableListController from "./focusable_list_controller"
application.register("focusable-list", FocusableListController)

import Forms__BillingContactController from "./forms/billing_contact_controller"
application.register("forms--billing-contact", Forms__BillingContactController)

import Forms__Document__LineItemController from "./forms/document/line_item_controller"
application.register("forms--document--line-item", Forms__Document__LineItemController)

import Forms__Document__ReceivableController from "./forms/document/receivable_controller"
application.register("forms--document--receivable", Forms__Document__ReceivableController)

import Forms__Document__ReturnController from "./forms/document/return_controller"
application.register("forms--document--return", Forms__Document__ReturnController)

import Forms__DocumentController from "./forms/document_controller"
application.register("forms--document", Forms__DocumentController)

import Forms__ExonerationsController from "./forms/exonerations_controller"
application.register("forms--exonerations", Forms__ExonerationsController)

import Forms__FilterCollectionAutocompleteController from "./forms/filter_collection_autocomplete_controller"
application.register("forms--filter-collection-autocomplete", Forms__FilterCollectionAutocompleteController)

import Forms__PhysicalInventory__LineItemController from "./forms/physical_inventory/line_item_controller"
application.register("forms--physical-inventory--line-item", Forms__PhysicalInventory__LineItemController)

import Forms__PricingListController from "./forms/pricing_list_controller"
application.register("forms--pricing-list", Forms__PricingListController)

import Forms__PricingListProductsController from "./forms/pricing_list_products_controller"
application.register("forms--pricing-list-products", Forms__PricingListProductsController)

import Forms__SynchroFieldsController from "./forms/synchro_fields_controller"
application.register("forms--synchro-fields", Forms__SynchroFieldsController)

import Forms__ValidatableModalController from "./forms/validatable_modal_controller"
application.register("forms--validatable-modal", Forms__ValidatableModalController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import Inputs__AutocompleteController from "./inputs/autocomplete_controller"
application.register("inputs--autocomplete", Inputs__AutocompleteController)

import Inputs__CantonController from "./inputs/canton_controller"
application.register("inputs--canton", Inputs__CantonController)

import Inputs__CurrencyController from "./inputs/currency_controller"
application.register("inputs--currency", Inputs__CurrencyController)

import Inputs__DateController from "./inputs/date_controller"
application.register("inputs--date", Inputs__DateController)

import Inputs__DropzoneController from "./inputs/dropzone_controller"
application.register("inputs--dropzone", Inputs__DropzoneController)

import Inputs__FileController from "./inputs/file_controller"
application.register("inputs--file", Inputs__FileController)

import Inputs__ImaskController from "./inputs/imask_controller"
application.register("inputs--imask", Inputs__ImaskController)

import Inputs__LocationController from "./inputs/location_controller"
application.register("inputs--location", Inputs__LocationController)

import Inputs__MoneyController from "./inputs/money_controller"
application.register("inputs--money", Inputs__MoneyController)

import Inputs__MultiLevelSelectController from "./inputs/multi_level_select_controller"
application.register("inputs--multi-level-select", Inputs__MultiLevelSelectController)

import Inputs__PasswordController from "./inputs/password_controller"
application.register("inputs--password", Inputs__PasswordController)

import Inputs__PercentageOrCurrencyController from "./inputs/percentage_or_currency_controller"
application.register("inputs--percentage-or-currency", Inputs__PercentageOrCurrencyController)

import Inputs__PhoneController from "./inputs/phone_controller"
application.register("inputs--phone", Inputs__PhoneController)

import Inputs__ProductWithUnitController from "./inputs/product_with_unit_controller"
application.register("inputs--product-with-unit", Inputs__ProductWithUnitController)

import Inputs__ProvinceController from "./inputs/province_controller"
application.register("inputs--province", Inputs__ProvinceController)

import Inputs__QuantityWithUnit__EquivalenceController from "./inputs/quantity_with_unit/equivalence_controller"
application.register("inputs--quantity-with-unit--equivalence", Inputs__QuantityWithUnit__EquivalenceController)

import Inputs__QuantityWithUnitController from "./inputs/quantity_with_unit_controller"
application.register("inputs--quantity-with-unit", Inputs__QuantityWithUnitController)

import Inputs__ServiceController from "./inputs/service_controller"
application.register("inputs--service", Inputs__ServiceController)

import Inputs__ShowhideController from "./inputs/showhide_controller"
application.register("inputs--showhide", Inputs__ShowhideController)

import Inputs__TagsController from "./inputs/tags_controller"
application.register("inputs--tags", Inputs__TagsController)

import ItemsListController from "./items_list_controller"
application.register("items-list", ItemsListController)

import ListFiltersController from "./list_filters_controller"
application.register("list-filters", ListFiltersController)

import ListTableController from "./list_table_controller"
application.register("list-table", ListTableController)

import MenuBarController from "./menu_bar_controller"
application.register("menu-bar", MenuBarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import Modals__ConfirmController from "./modals/confirm_controller"
application.register("modals--confirm", Modals__ConfirmController)

import Modals__ConfirmDeleteMultipleController from "./modals/confirm_delete_multiple_controller"
application.register("modals--confirm-delete-multiple", Modals__ConfirmDeleteMultipleController)

import Selects__AccountController from "./selects/account_controller"
application.register("selects--account", Selects__AccountController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarMenuController from "./sidebar_menu_controller"
application.register("sidebar-menu", SidebarMenuController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UserNotificationsController from "./user_notifications_controller"
application.register("user-notifications", UserNotificationsController)

import ImportProductsController from "./import_products_controller"
application.register("import-products", ImportProductsController)

import Inputs__CsvFileController from "./inputs/csv_file_controller"
application.register("inputs--csv-file", Inputs__CsvFileController)
